import React from 'react'
import PropTypes from 'prop-types'

const ReportsRelated = ({ currentReport, reportsRelated }) => {
  return (
    <div className="reports-related-counter">
      <div className="circle">
        <span>{reportsRelated?.length}</span>
      </div>
      <div className="hover-content">
        <h5>Relación</h5>
        <hr />
        <div>
          <strong>Original</strong>
          <div>
            ID: {currentReport.id}, Folio: {currentReport.folio}
          </div>
        </div>
        {reportsRelated.length > 0 && (
          <div className='mt-3'>
            <strong>Duplicados</strong>
            {reportsRelated.map((report) => (
              <div key={report.id}>
                ID: {report.id}, Folio: {report.folio}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

ReportsRelated.propTypes = {
  currentReport: PropTypes.shape({
    id: PropTypes.number.isRequired,
    folio: PropTypes.string.isRequired,
    isOriginal: PropTypes.bool.isRequired,
    isDuplicated: PropTypes.bool.isRequired,
  }).isRequired,
  reportsRelated: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      folio: PropTypes.string.isRequired,
      isOriginal: PropTypes.bool.isRequired,
      isDuplicated: PropTypes.bool.isRequired,
    })
  ).isRequired,
}

export default ReportsRelated
